var _path, _line;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgPencil = function SvgPencil(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1249 2.10583C13.9798 1.96068 13.7829 1.87919 13.5776 1.8793C13.3723 1.87941 13.1755 1.96111 13.0305 2.10642L11.6514 3.4885L12.1989 4.03482L11.6514 3.4885L11.3649 3.7756L2.03224 13.1283C1.96051 13.2001 1.90364 13.2854 1.86488 13.3793L1.28515 14.7827C1.16582 15.0716 1.23209 15.4039 1.4531 15.6249C1.67411 15.8459 2.00641 15.9122 2.29529 15.7929L3.69872 15.2131C3.79258 15.1744 3.87788 15.1175 3.94975 15.0458L13.2989 5.71659L13.6 5.41612L14.9716 4.04749C15.1169 3.90249 15.1986 3.70569 15.1987 3.50041C15.1988 3.29514 15.1173 3.09825 14.9722 2.9531L14.5485 2.52947L14.1249 2.10583Z",
    strokeWidth: 1.54687,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 12.3536,
    y1: 3.64645,
    x2: 13.3536,
    y2: 4.64645
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPencil, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/pencil.3dc59962.svg";
export { ForwardRef as ReactComponent };